import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrInputComponent } from '../../../../shared/emr-input/emr-input.component';
import { EmrCheckboxComponent } from '../../../../shared/emr-checkbox/emr-checkbox.component';
import { ProviderNotifiedFormGroup } from 'src/app/calvin-emr-shared/models/assessments/provider-notified.model';

@Component({
  selector: 'app-provider-notified-form',
  standalone: true,
  imports: [
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AssessmentRowComponent,
    EmrInputComponent,
    EmrCheckboxComponent,
  ],
  template: `
    <div [formGroup]="formGroup()" class="form-container">
      <assessment-row title="Provider Notified?">
        <emr-checkbox [control]="formGroup().controls.isNotified" label="Yes"></emr-checkbox>
      </assessment-row>
      @if (formGroup().controls.isNotified.value) {
        <assessment-row title="Who">
          <emr-input type="text" [control]="formGroup().controls.notifiedPerson" />
        </assessment-row>
        <assessment-row title="What">
          <emr-input type="text" [control]="formGroup().controls.notifiedWhat" />
        </assessment-row>
      }
    </div>
  `,
  styleUrl: '../assessments-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProviderNotifiedFormComponent {
  formGroup = input.required<ProviderNotifiedFormGroup>();
}
